"use client";

/**
 * Error boundary racine (Next App Router). Capture les erreurs de rendu des
 * pages sous le layout racine. Doit être un Client Component (convention Next).
 * Le layout (Header/Footer) reste affiché ; seule la zone <main> est remplacée.
 */

import { useEffect } from "react";
import { ErrorView } from "@/components/feedback/ErrorView";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}): JSX.Element {
  useEffect(() => {
    // `digest` permet de corréler avec les logs serveur en production.
    console.error(error);
  }, [error]);

  return <ErrorView reset={reset} />;
}
